// export const PRODUCTION = process.env.NX_IS_PRODUCTION === 'true';

// export const STAGING = process.env.NX_IS_STAGING === 'true';

// export const BASE_URL = PRODUCTION
//   ? process.env.NX_BASE_URL_PRODUCTION
//   : STAGING
//   ? ''
//   : process.env.NX_BASE_URL_DEV;

  export const BASE_URL = 'https://dev.licorera3jjjs.com/api';
  export const EMAIL = 'admin@admin.com';
  export const PASSWORD = 'admin';

  export const GOOGLE_MAP_API_KEY = 'AIzaSyBsSA1CAEjidYGVeDHfHxnemdHMnCzjvh4';